import apiV2 from '@/utils/apiV2'

export const actions = {
  async requestLatestQuarterlyReport() {
    try {
      const { data } = await this.$fmAxiosV2.get(
        apiV2.intelligence.getLatestQir()
      )
      return data
    } catch (err) {
      throw err
    }
  },
  async requestPurchaseQirSingle(_, { pathParams, payload, headerParams }) {
    const settings = {
      headers: { GoogleCaptchaResponseKey: headerParams.captchaKey }
    }

    try {
      const { data } = await this.$fmAxiosV2.post(
        apiV2.intelligence.purchaseQirSingle(pathParams.id),
        payload,
        settings
      )
      return data
    } catch (err) {
      throw err
    }
  }
}
